module.exports = __webpack_public_path__ + "24e004ab/img/note-edit-icon.acae1669.svg";